import React from 'react';
import './TransactionTable.css';

interface Transaction {
  id: string;
  dateTime: string;
  instrument: string;
  type: 'rise' | 'fall' | 'digits' | 'accumulator';
  stake: string;
  status: 'won' | 'lost' | 'active';
  pnl: string;
  pnlType: 'positive' | 'negative';
  details: string;
}

interface TransactionTableProps {
  transactions: Transaction[];
  onRowClick?: (transaction: Transaction) => void;
}

const TransactionTable: React.FC<TransactionTableProps> = ({ transactions, onRowClick }) => {
  const getTypeLabel = (type: string) => {
    switch (type) {
      case 'rise': return 'Rise';
      case 'fall': return 'Fall';
      case 'digits': return 'Digits';
      case 'accumulator': return 'Acc';
      default: return type;
    }
  };

  const getStatusLabel = (status: string) => {
    switch (status) {
      case 'won': return 'Won';
      case 'lost': return 'Lost';
      case 'active': return 'Active';
      default: return status;
    }
  };

  return (
    <div className="transaction-table">
      <div className="table-header">
        <span>Date/Time</span>
        <span>Instrument</span>
        <span>Type</span>
        <span>Stake</span>
        <span>Status</span>
        <span>P&L</span>
        <span>Details</span>
      </div>
      
      {transactions.map((transaction) => (
        <div 
          key={transaction.id} 
          className="table-row"
          onClick={() => onRowClick?.(transaction)}
        >
          <div className="table-cell">{transaction.dateTime}</div>
          <div className="table-cell">{transaction.instrument}</div>
          <div className="table-cell">
            <div className="trade-type">
              <span className={`type-badge ${transaction.type}`}>
                {getTypeLabel(transaction.type)}
              </span>
            </div>
          </div>
          <div className="table-cell">{transaction.stake}</div>
          <div className="table-cell">
            <span className={`status-badge ${transaction.status}`}>
              {getStatusLabel(transaction.status)}
            </span>
          </div>
          <div className="table-cell">
            <span className={`pnl-value ${transaction.pnlType}`}>
              {transaction.pnl}
            </span>
          </div>
          <div className="table-cell">{transaction.details}</div>
        </div>
      ))}
    </div>
  );
};

export default TransactionTable;
